module.exports = __webpack_public_path__ + "static/media/house9.06820115.png";